import type { Error } from '../types';
import { CONTAIN_LOWERCASE_LETTER_REGEXP } from '../utils/regex';

export const mustContainLowerCaseLetter =
  (message?: Error['message']) =>
  (value: string): Error => ({
    valid: !!value && CONTAIN_LOWERCASE_LETTER_REGEXP.test(value),
    message
  });
